<div style="padding-left: 15px; padding-right: 15px;" class="row">
   <div class="component col-12">
      <div [innerHTML]="componentData.content" class="component-content"></div>
   </div>
</div>